/**
 * React DOM polyfill for react-native-web compatibility
 * Provides compatibility shims for deprecated React DOM APIs
 */

declare const window: any;

// Import directly from the actual react-dom package using require to avoid alias issues
// @ts-ignore
const ReactDOM = require('react-dom');

// Add polyfills for deprecated React DOM APIs
if (!ReactDOM.findDOMNode) {
  ReactDOM.findDOMNode = (instance: any) => {
    if (instance == null) return null;
    if (instance.nodeType) return instance;
    return null;
  };
}

if (!ReactDOM.hydrate) {
  ReactDOM.hydrate = (element: any, container: any, callback: any) => {
    if (ReactDOM.createRoot) {
      const root = ReactDOM.createRoot(container);
      root.render(element);
      if (callback) callback();
      return root;
    } else {
      console.warn('[reactDomPolyfill] Neither createRoot nor hydrate available');
      return null;
    }
  };
}

if (!ReactDOM.render) {
  ReactDOM.render = (element: any, container: any, callback: any) => {
    if (ReactDOM.createRoot) {
      const root = ReactDOM.createRoot(container);
      root.render(element);
      if (callback) callback();
      return root;
    } else {
      console.warn('[reactDomPolyfill] Neither createRoot nor render available');
      return null;
    }
  };
}

if (!ReactDOM.unmountComponentAtNode) {
  ReactDOM.unmountComponentAtNode = (container: any) => {
    if (container._reactRootContainer) {
      container._reactRootContainer.unmount();
      delete container._reactRootContainer;
      return true;
    }
    return false;
  };
}

// Ensure createRoot exists and works
if (!ReactDOM.createRoot) {
  console.warn('[reactDomPolyfill] React DOM does not have createRoot, this is likely React < 18');
}

// Make ReactDOM globally available for shims
if (typeof window !== 'undefined') {
  (window as any).__REACT_DOM__ = ReactDOM;
}

export default ReactDOM;
export { ReactDOM };
